import React from 'react';
import { Button } from '@/components/ui/button';

interface PasswordChangeConfirmationProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export const PasswordChangeConfirmation: React.FC<PasswordChangeConfirmationProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="password-confirmation-modal">
        {/* Lock Icon */}
        <div className="flex justify-center mb-6">
          <div className="flex items-center justify-center">
            <img src="/lock.png" alt="Lock" className="w-20 h-[102px]" />
          </div>
        </div>

        {/* Title */}
        <h2 className="text-white password-confirmation-title">
          Are you sure you want to change your password?
        </h2>

        {/* Description */}
        <p className="text-white password-confirmation-description">
          This will update your login credentials.
        </p>

        {/* Buttons */}
        <div className="flex gap-4 justify-center mt-10">
          <Button
            onClick={onClose}
            disabled={isLoading}
            className="password-confirmation-cancel-button"
          >
            Cancel
          </Button>
          
          <Button
            onClick={onConfirm}
            disabled={isLoading}
            className="password-confirmation-confirm-button"
          >
            {isLoading ? 'Updating...' : 'Yes, Change Password'}
          </Button>
        </div>
      </div>
    </div>
  );
};
